'use client';
import { Button, ButtonProps } from '@nextui-org/react';

type BasicButtonProps = ButtonProps & { className?: string };

export default function BasicButton(props: BasicButtonProps) {
  return (
    <Button {...props} className={`${props.className} rounded-[4px]`}>
      {props.children}
    </Button>
  );
}
